export enum Step {
  OTP,
  FORM,
  LIST,
}
